import { createAction, props } from '@ngrx/store';
import { CommentCreationModel, CommentModel } from '../../models';

const LoadAllCommentsAction = createAction('[Comment/API] load all comments');

const AllCommentsLoadedAction = createAction(
  '[Comment/API] all comments loaded',
  props<{ comments: CommentModel[] }>(),
);

/** Create actions */
const OptimisticCreateCommentAction = createAction(
  '[Comment/API] optimistic create',
  props<{ comment: CommentCreationModel; operationId: string }>(),
);

const CreateCommentAction = createAction(
  '[Comment/API] create comment',
  props<{ comment: CommentCreationModel; operationId: string }>(),
);

const CommentCreatedAction = createAction('[Comment/API] comment created', props<{ comment: CommentModel }>());

const CreateCommentFailedAction = createAction(
  '[Comment/API] failed to create comment',
  props<{ comment: CommentCreationModel }>(),
);

const UpdateCommentBodyAction = createAction(
  '[Comment/API] update comment body',
  props<{ commentId: string; newBody: string; mentionedEmails?: string[]; extraParams?; operationId: string }>(),
);

const CommentUpdatedAction = createAction(
  '[Comment/API] comment updated',
  props<{ updatedComment: CommentModel; id?: string }>(),
);

const UpdateCommentFailedAction = createAction(
  '[Comment/API] failed to update comment',
  props<{ commentBeforeUpdate: CommentModel }>(),
);

/** Delete actions */
const DeleteCommentAction = createAction(
  '[Comment/API] delete comment',
  props<{ commentId: string; operationId: string }>(),
);

const CommentDeletedAction = createAction('[Comment/API] comment deleted', props<{ deletedComment: CommentModel }>());

const DeleteCommentFailedAction = createAction(
  '[Comment/API] failed to delete comment',
  props<{ deletedComment: CommentModel }>(),
);

export const CommentAction = {
  LoadAll: LoadAllCommentsAction,
  AllLoaded: AllCommentsLoadedAction,
  OptimisticCreate: OptimisticCreateCommentAction,
  Create: CreateCommentAction,
  Created: CommentCreatedAction,
  CreateFailed: CreateCommentFailedAction,
  UpdateBody: UpdateCommentBodyAction,
  Updated: CommentUpdatedAction,
  UpdateFailed: UpdateCommentFailedAction,
  Delete: DeleteCommentAction,
  Deleted: CommentDeletedAction,
  DeleteFailed: DeleteCommentFailedAction,
};
